import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
@Injectable({
  providedIn: 'root'
})
export class FormService {

  constructor(
    private _http: HttpClient
  ) { }

  saveTemplate(requestData) {
    return this._http.post(environment.url + "/saveTemplate", requestData);
  }

  updateTemplate(requestData) {
    return this._http.post(environment.url + "/updateTemplate", requestData, { headers: { "hideLoader": "true" }});
  }

  getTemplateById(id) {
    return this._http.get(environment.url + "/getTemplateById/" + id);
  }

  getTemplateByURLId(urlId: string) {
    return this._http.get(environment.url + "/getTemplateByURLId/" + urlId);
  }

  getActionTypes(id) {
    return this._http.get(environment.url + "/actionTypes/" + id);
  }

  createActionType(actionType) {
    return this._http.post(environment.url + "/actionTypes/", actionType);
  }

  addActionTypeToForms(data) {
    return this._http.post(environment.url + "/forms/actionType", data);
  }

  unmarkImportant(requestData) {
    return this._http.put(environment.url + "/forms/unMarkImportant", requestData);
  }

  archiveForms(requestData) {
    return this._http.post(environment.url + "/forms/archive", requestData)
  }

  deleteForms(requestData) {
    return this._http.post(environment.url + "/forms/delete", requestData)
  }

  cloneTemplateToOtherOrg(templateId: string, organizationId: string) {
    return this._http.post(`${environment.url}/template/clone`, { templateId: templateId, organizationId: organizationId })
  }
}
